module.exports = __webpack_public_path__ + "img/40_38_032_120.0bdf1fe6.jpg";